import { LogicCondition } from '@leverege/condition';
import { ModelFactory } from '@leverege/ui-plugin';
export default {
  id: 'molten.filter.condition.configurer.imagine',
  matches: {
    delegateType: 'imagine.GroupDelegate'
  },
  configure: (model, ...rest) => {
    const Model = ModelFactory.get(model);
    return Model.setRootCondition(model, LogicCondition.create({
      operator: 'and'
    }));
  }
};